import { useQuery } from "react-query";
import { RiwayatPekerjaanResponse } from "../../../../models/RiwayatPekerjaan";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const allRiwayatPekerjaanKey = "all-riwayat-pekerjaan-key";

export async function allRiwayatPekerjaan(): Promise<
  RiwayatPekerjaanResponse[]
> {
  const res = await ApiClient.get(`/AllPekerjaan`);
  return res.data;
}

export default function useFetchAllRiwayatPekerjaan() {
  return useQuery([allRiwayatPekerjaanKey], queryWrapper(allRiwayatPekerjaan));
}
